import { Injectable } from '@angular/core';
import {
	AttestationPresenceThematiqueSummary,
	AttestationPresenceThematiqueSummaryInterface,
	AttestationPresenceThematiqueSummaryPayload,
} from './attestation-presence-thematique-summary';
import { AttestationPresenceThematiqueSummarySearchParamsInterface } from './attestation-presence-thematique-summary-search-params';
import { BaseModelService } from '@app/abstracts';
@Injectable()
export class AttestationPresenceThematiqueSummaryService extends BaseModelService<
	AttestationPresenceThematiqueSummary,
	AttestationPresenceThematiqueSummaryInterface,
	AttestationPresenceThematiqueSummaryPayload,
	AttestationPresenceThematiqueSummarySearchParamsInterface
> {
	/** @inheritDoc */
	protected path(): string {
		return 'attestation-presence-thematique-summary';
	}
	/** @inheritDoc */
	protected new(
		object: AttestationPresenceThematiqueSummaryInterface
	): AttestationPresenceThematiqueSummary {
		return new AttestationPresenceThematiqueSummary(object);
	}

	/**
	 * View/download document for attestation presence thematique summary
	 * @param id - Summary ID
	 * @returns PDF blob
	 */
	viewDocument(id: string): Promise<Blob> {
		return this.http
			.get(`${this.uri(true)}/${id}/document`, {
				withCredentials: true,
				responseType: 'blob',
			})
			.toPromise();
	}

	/**
	 * Get presigned URL for viewing/downloading summary document
	 * @param id - Summary ID
	 * @returns Object with presigned URL
	 */
	getPresignedUrl(id: string): Promise<{ url: string }> {
		const options = {
			withCredentials: true,
		};
		return this.http
			.get<{ url: string }>(`${this.uri(true)}/${id}/document`, options)
			.toPromise();
	}

	/**
	 * Upload signed document for attestation presence thematique summary
	 * @param id - Summary ID
	 * @param file - PDF file to upload
	 * @returns Updated summary with uploaded document
	 */
	uploadDocument(
		id: string,
		file: File
	): Promise<AttestationPresenceThematiqueSummary> {
		const formData = new FormData();
		formData.append('file', file);
		const options = {
			withCredentials: true,
		};
		return this.http
			.post<AttestationPresenceThematiqueSummaryInterface>(
				`${this.uri()}/${id}/upload`,
				formData,
				options
			)
			.toPromise()
			.then((result) => this.new(result));
	}
}
